import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ActivatedRoute } from '@angular/router';
import { ValidationErrors, AbstractControl, FormGroup, FormControl, Validators } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';
import { AlertBoxType } from '../base/alert-box/alertboxtype';
import { FormComponent } from '../base/form/form.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends FormComponent implements OnInit {

  public isPasswordChangeAllowed: boolean;

  public email: string;
  
  private resetHash: string;

  public changePasswordForm = new FormGroup({
    password: new FormControl('', [Validators.required, this.validatorPatternPassword]),
    confirmPassword: new FormControl('', [Validators.required, this.matchValues('password')]),
  });

  public formResponse: FormResponse;

  public alertBoxTypes = AlertBoxType;

  public submitDisabled = false;

  constructor(private activatedRoute: ActivatedRoute, private accountService: AccountService) {
    super();

    this.activatedRoute.queryParams.subscribe(params => {
        this.email = params['email'];
        this.resetHash = params['regkey'];
    });
  }

  ngOnInit(): void {
    this.accountService.isPasswordChangeAllowed(this.email, this.resetHash).subscribe((result: boolean) => {
      this.isPasswordChangeAllowed = result;
    });
  }

  get password() { return this.changePasswordForm.get('password'); }
  get confirmPassword() { return this.changePasswordForm.get('confirmPassword'); }

  public onSubmit() {

    if (this.changePasswordForm.valid) {
      this.submitDisabled = true;
      this.accountService.changePassword(this.email, this.password.value, this.resetHash).subscribe((result: FormResponse) => {
          this.formResponse = result;

          if (this.formResponse.result === true) {
            this.changePasswordForm.reset();
          }

          this.submitDisabled = false;
      });
    } else {
      this.password.markAsDirty();
      this.confirmPassword.markAsDirty();
    }
  }

  public hasErrors() {
    return this.formResponse !== undefined && this.formResponse.errors !== undefined && this.formResponse.errors.length > 0;
  }
}
